import React from 'react';
import {
  ConfigSection, Groups, StyledInput, ColorSelection, ColorButton,
  TextArea, Button, SelectFont, SelectNumber, ButtonEliminarTexto,
  ImageCarousel, UploadButton, PlusIcon, ThumbnailWrapper, Thumbnail,
  DeleteButton
} from '../Canvas.styles.js';
import Label from '../../Label/Label';
import RadioButtons from '../../Buttons/RadioButtons';
import {
  contentTypeOptions, NEON_COLORS, NEON_FONTS, cutOptions,
  suportOptions, useOptions, FONT_SIZES
} from '../../../constants/options';

const ConfigPanel = ({
  contentType,
  onContentTypeChange,
  texts,
  setTexts,
  selectedTextId,
  setSelectedTextId,
  uploadedImages,
  setUploadedImages,
  uploadedImageSrc,
  setUploadedImageSrc,
  description,
  setDescription,
  size,
  setSize,
}) => {
  // Funciones para manejo de texto
  const handleTextChange = (id, newText) => {
    setTexts(prev =>
      prev.map(text =>
        text.id === id ? { ...text, text: newText } : text
      )
    );
  };

  const handleFontChange = (id, newFont) => {
    setTexts(prev =>
      prev.map(text =>
        text.id === id ? { ...text, fontFamily: newFont } : text
      )
    );
  };

  const handleColorChange = (id, newColor) => {
    setTexts(prev =>
      prev.map(text =>
        text.id === id ? { ...text, color: newColor } : text
      )
    );
  };

  const handleFontSizeChange = (id, newSize) => {
    setTexts(prev =>
      prev.map(text =>
        text.id === id ? { ...text, fontSize: newSize } : text
      )
    );
  };

  const handleDeleteText = (id) => {
    setTexts(prev => prev.filter(text => text.id !== id));
    setSelectedTextId(null);
  };

  const addText = () => {
    const newText = {
      id: Date.now(),
      text: 'INGRESE AQUI SU TEXTO',
      x: 250 - 300, 
      y: 250,
      fontFamily: NEON_FONTS[0].value,
      color: NEON_COLORS[0].value,
      fontSize: 35,
      offsetX: 0,
      offsetY: 0,
    };
    setTexts(prev => [...prev, newText]);
    setSelectedTextId(newText.id);
  };

  // Funciones para manejo de imágenes
  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file.type !== "image/svg+xml") {
        alert("⚠ Solo se permiten imágenes en formato SVG.");
        event.target.value = ""; // Reiniciar el input
        return;
    }
    if (file && uploadedImages.length < 4) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newImage = e.target.result;
        setUploadedImages(prev => [...prev, newImage]);
        setUploadedImageSrc(newImage);
      };
      reader.readAsDataURL(file);
    } else if (uploadedImages.length >= 4) {
      alert('Solo se permiten hasta 4 imágenes');
    }
  };

  const handleDeleteImage = (indexToDelete) => {
    setUploadedImages(prev => prev.filter((_, index) => index !== indexToDelete));
    if (uploadedImageSrc === uploadedImages[indexToDelete]) {
      setUploadedImageSrc(null);
    }
  };

  // Panel de configuración basado en el tipo de contenido seleccionado
  return (
    <>
      <ConfigSection>
        <Label title={'SVG - TEXTO'} />
        <RadioButtons
          options={contentTypeOptions}
          name="contentType"
          onChange={onContentTypeChange}
        />
      </ConfigSection>

      {contentType === 'text' && (
        <ConfigSection>
          {/* Mostrar los inputs para el texto seleccionado */}
          {selectedTextId && (
            <div>
              <Label title={'ESCRIBE TU TEXTO'} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <StyledInput
                  type="text"
                  value={texts.find(text => text.id === selectedTextId)?.text || ''}
                  onChange={(e) => handleTextChange(selectedTextId, e.target.value)}
                  style={{ height: '44px' }}
                />
                <ButtonEliminarTexto onClick={() => handleDeleteText(selectedTextId)}>
                  ELIMINAR TEXTO
                </ButtonEliminarTexto>
              </div>
              <ConfigSection>
                <Label title={'SELECCIONAR FUENTE'} />
                <SelectFont
                  onChange={(e) => handleFontChange(selectedTextId, e.target.value)}
                  value={texts.find(text => text.id === selectedTextId)?.fontFamily || NEON_FONTS[0].value}
                  style={{ fontFamily: texts.find(text => text.id === selectedTextId)?.fontFamily }}
                >
                  {NEON_FONTS.map(font => (
                    <option
                      key={font.value}
                      value={font.value}
                      style={{ fontFamily: font.value }}
                    >
                      {font.label}
                    </option>
                  ))}
                </SelectFont>
              </ConfigSection>
              <ConfigSection>
                <Label title={'TAMAÑO DE FUENTE'} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px',}}>
                  <StyledInput
                    type="number"
                    min="8"
                    max="100"
                    step="1"
                    value={texts.find(text => text.id === selectedTextId)?.fontSize || 40}
                    onChange={(e) => handleFontSizeChange(selectedTextId, parseInt(e.target.value, 10))}
                    style={{ width: '60px' }}
                  />
                  <SelectNumber
                    value={texts.find(text => text.id === selectedTextId)?.fontSize || ''}
                    onChange={(e) => handleFontSizeChange(selectedTextId, parseInt(e.target.value, 10))}
                  >
                    <option value="">Seleccionar</option>
                    {FONT_SIZES.map(size => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </SelectNumber>
                </div>
              </ConfigSection>
              <ColorSelection>
                {NEON_COLORS.map(color => (
                  <ColorButton
                    key={color.value}
                    color={color.value}
                    selected={texts.find(text => text.id === selectedTextId)?.color === color.value}
                    onClick={() => handleColorChange(selectedTextId, color.value)}
                  />
                ))}
              </ColorSelection>
            </div>
          )}
          <Button onClick={addText}>AGREGAR NUEVO TEXTO</Button>
        </ConfigSection>
      )}

      {contentType === 'image' && (
        <ConfigSection>
          <ImageCarousel>
            {uploadedImages.length < 4 && (
              <UploadButton>
                <input type="file" onChange={handleImageUpload} accept="image/*" />
                <PlusIcon>+</PlusIcon>
              </UploadButton>
            )}
            {uploadedImages.map((img, index) => (
              <ThumbnailWrapper key={index}>
                <Thumbnail
                  src={img}
                  alt={`Uploaded ${index + 1}`}
                  onClick={() => setUploadedImageSrc(img)}
                  selected={uploadedImageSrc === img}
                />
                <DeleteButton onClick={() => handleDeleteImage(index)}>
                  X
                </DeleteButton>
              </ThumbnailWrapper>
            ))}
          </ImageCarousel>
          <ConfigSection>
            <Label title={'DESCRIPCIÓN'} />
            <TextArea
              placeholder="Añade una descripción de tu Neón"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </ConfigSection>
        </ConfigSection>
      )}


      <ConfigSection>
        <Label title={'TAMAÑO EN CENTIMETROS'} />
        <Groups>
          <StyledInput
            type="text"
            placeholder="ANCHO"
            value={size.width}
            onChange={(e) => setSize({ ...size, width: e.target.value })}
          />
          <StyledInput
            type="text"
            placeholder="ALTO"
            value={size.height}
            onChange={(e) => setSize({ ...size, height: e.target.value })}
          />
        </Groups>
        </ConfigSection>
      <ConfigSection>
              <Label title={'RECORTE'} />
              <RadioButtons
                options={cutOptions}
                name="cutOptions"
              />
            </ConfigSection>
            <ConfigSection>
              <Label title={'SOPORTE'} />
              <RadioButtons
                options={suportOptions}
                name="suportOptions"
              />
            </ConfigSection>
            <ConfigSection>
              <Label title={'USO'} />
              <RadioButtons
                options={useOptions}
                name="useOptions"
              />
            </ConfigSection>
    </>
  );
};

export default ConfigPanel;